














import { Component, Vue } from 'vue-property-decorator';
import detailRecord from './detailRecord.vue';
import { getRecordById } from '@/apis/sheet';
import { SheetModule } from '@/store/modules/sheet';
import { permissionE } from '@/views/sheet/widget/types';
import { AppModule } from '@/store/modules/app';
@Component({
	components: {
		detailRecord,
	},
})
export default class extends Vue {
	private priorityAuth = {}; // 锁定权限
	private actionShow = false;
	private hideRow = [];
	private titleField = '';
	private get isCep() {
		return AppModule.containerType === 'cep';
	}
	private getRecordList(type, data) {
		if (type === 'add') {
			if (!this.isCep) {
				const { applicationId, worksheetId, viewId } = this.$route.params;
				this.$router.replace(`/${applicationId}/${worksheetId}/sheet/${viewId}/${data.id}`);
			} else {
				this.$router.go(-1);
			}
		}
	}
	private async getSheetConfig(worksheetId) {
		if (SheetModule.sheetFieldList.length) {
			return true;
		} else {
			await SheetModule.getSheetConfig({
				worksheetId,
				queryFieldType: 1,
				isQueryView: false,
				isNeedAuthority: true,
			});
		}
	}
	private beforeRouteUpdate(to, from, next) {
		next();
		this.getRecord();
	}
	private getRecord() {
		this.$nextTick(async () => {
			let { recordId, worksheetId, viewId } = this.$route.params;
			await this.getSheetConfig(worksheetId);
			let detail = this.$refs.detailRecord as detailRecord;
			this.priorityAuth = {};
			if (recordId === 'addRecord') {
				this.hideRow = [];
				detail.initForm();
			} else {
				await SheetModule.getsViewHideRow(viewId);
				this.hideRow = SheetModule.hideRowMap[viewId];
				getRecordById({ worksheetId, id: recordId, viewId }).then((res) => {
					if (res.success) {
						let lockAuth = {};
						if (res.data.lockFieldAuthority) {
							res.data.lockFieldAuthority.forEach(({ businessId, authority }) => {
								lockAuth[businessId] = authority;
							});
							let sheetFieldList = this.$store.state.sheet.sheetFieldList;
							sheetFieldList.forEach((item) => {
								if (!lockAuth[item.businessId]) {
									lockAuth[item.businessId] =
										item.permissions && item.permissions.includes(permissionE.hidden)
											? 'hidden'
											: 'visible';
								}
							});
						}
						this.priorityAuth = lockAuth;
						detail.initForm(res.data);
					}
				});
			}
		});
	}
	private mounted() {
		this.getRecord();
	}
}
